module.exports = __webpack_public_path__ + "static/media/usecases_bg.a71fb9da.png";